<template>
	<main class="vx-row">
		<div class="vx-col w-full md:w-5/6 lg:w-1/2">

			<div class="block mb-6">
				<a href="#" @click.prevent="viewTransaction('ppob')" class="flex items-center">
					<img src="/assets/images/profile/transaction/zx.png" class="w-16 md:w-12 mr-4" alt="" />
					<strong class="text-dark">Layanan ZX</strong>
				</a>
			</div>

			<div class="block mb-6">
				<a href="#" @click.prevent="viewTransaction('zis')" class="flex items-center">
					<img src="/assets/images/profile/transaction/zx.png" class="w-16 md:w-12 mr-4" alt="" />
					<strong class="text-dark">ZIS</strong>
				</a>
			</div>

			<div class=" mb-6">
				<a href="#" @click="viewTransaction('campaign')" class="flex items-center">
					<img src="/assets/images/profile/transaction/donasi.png" class="w-16 md:w-12 mr-4" alt="" />
					<strong class="text-dark">Donasi</strong>
				</a>
			</div>

			<div class="block mb-6">
				<a href="#" @click.prevent="viewTransaction('qurban')" class="flex items-center">
					<img src="/assets/images/profile/transaction/qurban.svg" class="w-16 md:w-12 mr-4" alt="" />
					<strong class="text-dark">Qurban</strong>
				</a>
			</div>

		</div>
	</main>
</template>
<script>
	export default {
		methods: {
			viewTransaction(type) {
				this.$emit('viewTransaction', type)
			}
		}
	}
</script>